import { Trash2Icon, X } from "lucide-react";
import React, { useState, useRef, useEffect } from "react";
import { FaImage, FaTrash } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import Sidebar from "../../components/Sidebar";


function AdminLayout() {

  const [loading, setLoading] = useState(true);
  const [banner, setBanner] = useState({
    title: "",
    subtitle: "",
    description: "",
    video: "", 
  });

  const [gallery, setGallery] = useState([]);
  const [addGallery, setAddGallery] = useState(null);
  const [editId, setEditId] = useState(null);

  const fetchGallery = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}api/heroitem`);

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const note = await res.json();
      const list = Array.isArray(note) ? note : note.data || [];

      setGallery(list);
    } catch (err) {
      console.error("Gagal mengambil data:", err);
    }
  };
  
  useEffect(() => {
    fetchGallery();
  }, []);

  const [videoFile, setVideoFile] = useState(null);
  const fetchBanner = async () => {

    try {
        const res = await fetch(
            `${process.env.REACT_APP_BASE_URL}api/hero/1`
        );

        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const json = await res.json();
        setBanner(json.data || []);

    } catch (err) {
        console.error("Fetch Pc error:", err);
    }
  };

  useEffect(() => {
    fetchBanner();
  }, []);

  const handleAdd = (event) => {
    setAddGallery(event);
    setFormDataGallery({ title:event.title, category:event.category, description:event.description, thumb:event.thumb  });
  };

  const location = useLocation();
  const pageTitles = {
    "/": "Form Ajuan",
    "/admin/": "Halaman Admin",
    "/dashboard": "Dashboard",
    "/profile": "Profile",
    "/events": "Master Data Event",
    "/vendors": "Master Data Vendor",
    "/approval": "Master Data Approval",
    "/bank": "Master Data Akun Bank",
    "/account": "Pengaturan Akun",
    "/filteredRf": "Hasil Filter Tanggal",
    "/updateRf/": "Update Ajuan",
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  const [formDataGallery, setFormDataGallery] = useState({ title:'', category:'', description:'', thumb:''});

  const handleEditClick = (item) => {
    setEditId(item.id);

    setFormDataGallery({
      title: item.title,
      description: item.description,
      category: item.category,
      thumb: null
    });

    setAddGallery(true); // buka modal
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: 'Yakin hapus Galeri ini?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Ya, hapus',
      cancelButtonText: 'Batal',
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${process.env.REACT_APP_BASE_URL}api/heroitem/${id}`, {
          method: 'DELETE',
        })
          .then((res) => res.json())
          .then(() => {
            Swal.fire('Terhapus!', 'Image berhasil dihapus.', 'success');
            fetchGallery();
          });
      }
    });
  };

  const updateBanner = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();

      // append text fields
      formData.append("title", banner.title);
      formData.append("description", banner.description);

      // append video jika ada
      if (videoFile) {
        formData.append("video", videoFile);
      }

      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/hero/1`,
        {
          method: "POST",
          body: formData, // 
        }
      );

      if (!res.ok) throw new Error("Gagal update");

      const result = await res.json();

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Data berhasil diperbarui!",
        showConfirmButton: false,
        timer: 3000,
      });

    } catch (err) {
      Swal.fire("Error", "Gagal update data", "error");
    } finally {
      setLoading(false);
    }
  };

  const onChangeBanner = (e) => {
    const { name, value } = e.target;

    setBanner((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  
  const onChangeBannerVideo = (e) => {
    const file = e.target.files[0];

    if (file) {    
      setVideoFile(file);
    }
  };  

  const handleInsert = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();
      formData.append("file", formDataGallery.file);

      const response = await fetch(`${process.env.REACT_APP_BASE_URL}api/heroitem/insert`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {

        // Reset form
        setFormDataGallery({
          file: "",
        });

        setAddGallery(null);
        await fetchGallery();
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Gambar berhasil ditambahkan!",
          showConfirmButton: false,
          timer: 3000,
        });
      } else {
        alert(result.message || "Gagal menyimpan data");
      }
    } catch (error) {
      console.error(error);
      alert("Terjadi kesalahan");
    }
  };

  return (
    <div className="min-h-screen bg-white text-white">
      {/* Header Section */}
      <section 
        data-section="header"
        className="py-24 pt-40 bg-gradient-to-b from-slate-900 to-slate-950 relative overflow-hidden"
      >
        <div className="absolute inset-0">
          <img
            src="/images/bg-hero-about-us.jpeg"
            alt="background"
            className="w-full h-full object-cover opacity-20"
          />
        </div>

        <div className={`relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-1000 opacity-100 translate-y-0
        }`}>
          <h1 className="font-bricolage text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-red-600  to-[#3E3274] bg-clip-text text-transparent">
            Halaman Admin
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-red-600  to-[#3E3274] mx-auto mb-6"></div>
        </div>
      </section>
      <section 
        data-section="contact"
        className="py-24 bg-white"
      >
        <div className='flex flex-row max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 delay-200'>
          <div className='w-1/4'>
            <Sidebar></Sidebar>
          </div>
          <div className='w-3/4 p-4 bg-gray-800 text-white flex-col md:relative md:flex rounded-3xl '>
            <div className='flex flex-col pb-4'>
              <div className='p-4 text-xl font-medium'>
                Section Banner
              </div>
              <div className='grid grid-cols-3 gap-4'>
                <div className='p-4'>
                  <label className="block mb-1 font-medium ">Title</label>
                  <input
                    name='title'
                    type="text"
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={banner?.title}
                    onChange={onChangeBanner}
                    required
                  />
                </div>
                <div className='p-4'>
                  <label className="block mb-1 font-medium ">Description</label>
                  <textarea
                    name='description'
                    className="w-full text-black border px-3 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    value={banner?.description}
                    onChange={onChangeBanner}
                    required
                    rows={4}
                  />
                </div>
                <div className='p-4'>
                  <label className="block mb-1 font-medium ">Video Tengah</label>
                  <input
                    type="file"
                    name='video'
                    accept="video/*"
                    onChange={onChangeBannerVideo}
                    className="block w-full text-sm file:mr-4 file:py-2 file:px-4
                    file:rounded-md file:border-0
                    file:bg-blue-600 file:text-white
                    hover:file:bg-blue-700 mb-4"
                  />  
                </div>

              </div>
              <div className='flex flex-row'>
                <div className='w-1/3 p-4'>
                  <button onClick={updateBanner} className='p-4 rounded-full bg-gradient-to-r from-red-600  to-[#3E3274] hover:shadow-xl hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300'>Simpan</button>
                </div>
              </div>

              <div className="p-4">
                <table class="min-w-full divide-y divide-gray-200 bg-gradient-to-b from-slate-900 to-slate-950 text-gray-400">
                  <thead class="font-bricolage font-bold mb-4 bg-gradient-to-r from-red-600  to-[#3E3274] text-transparent">
                    <tr>
                      <th className="p-2 font-medium text-white text-center">Image</th>
                      <th className="p-2 font-medium text-white text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {Array.isArray(gallery) && gallery.map((a, idx) => (
                      <>
                        <tr className="hover:bg-gray-500">
                          <td className="p-4 text-white flex flex-row justify-center items-center text-center">
                            <img className='max-h-64' src={`${process.env.REACT_APP_BASE_URL}uploads/images/${a.file}`} />
                          </td>
                          <td className="p-4 text-white text-center">
                            <div className='flex flex-row gap-4 items-center justify-center'>
                              <FaTrash onClick={() => handleDelete(a.id)} className='cursor-pointer'></FaTrash>
                            </div>
                          </td>
                        </tr>
                      </>
                      ))
                    }
                  </tbody>
                </table>
                <div className='flex flex-row'>
                  <div className='w-1/3 p-4'>
                    <button onClick={handleAdd} className='p-4 rounded-full bg-gradient-to-r from-blue-600/30 to-red-600/30 hover:shadow-xl hover:shadow-blue-500/50 transform hover:scale-105 transition-all duration-300'>Tambah</button>
                  </div>
                </div>
              </div>
            </div>
            {addGallery && (
              <div
                className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-50 p-4"
                onClick={() => {
                  setAddGallery(null);
                  setEditId(null);
                }}
              >
                <div
                  className="bg-white text-black p-6 rounded-2xl w-full max-w-md relative shadow-2xl max-h-[90vh] overflow-y-auto"
                  onClick={(e) => e.stopPropagation()}
                >
                  {/* Close Button */}
                  <button
                    className="absolute top-3 right-3 text-gray-500 hover:text-red-500 transition"
                    onClick={() => {
                      setAddGallery(null);
                      setEditId(null);
                    }}
                  >
                    <X size={20} />
                  </button>
      
                  {/* Title */}
                  <h3 className="text-xl font-bold mb-6 text-center">
                    {editId
                      ? "Edit Galeri"
                      : "Tambah Galeri "}
                  </h3>
      
                  {/* Form */}
                  <form
                    onSubmit={handleInsert}
                    className="space-y-4"
                  >
                    <div>
                      <label className="block font-medium mb-1">Image</label>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) =>
                          setFormDataGallery({
                            ...formDataGallery,
                            file: e.target.files[0],
                          })
                        }
                        className="w-full border border-gray-300 p-2 rounded-lg"
                      />
                      
                      <span className='text-sm text-red-600'><i>*rekomendasi file type: .png, .jpg, .jpeg</i></span>
      
                      {/* Preview Image */}
                      {formDataGallery.file && (
                        <img
                          src={URL.createObjectURL(formDataGallery.file)}
                          alt="preview"
                          className="mt-3 h-20 object-contain rounded-lg border"
                        />
                      )}
                    </div>
      
                    {/* Buttons */}
                    <div className="flex justify-end gap-3 pt-4">
                      <button
                        type="button"
                        className="px-4 py-2 bg-gray-200 rounded-full hover:bg-gray-300 transition"
                        onClick={() => {
                          setAddGallery(null);
                          setEditId(null);
                        }}
                      >
                        Batal
                      </button>
      
                      <button
                        type="submit"
                        className="px-6 py-2 rounded-full bg-gradient-to-r from-blue-600 to-red-600 text-white hover:shadow-lg transform hover:scale-105 transition-all duration-300"
                      >
                        Simpan
                      </button>
                    </div>
                  </form>
                </div>
                
              </div>
            )}
          </div>
        </div>
      </section>
      
    </div>
  );
}

export default AdminLayout;
